import type { Metadata } from "next";
import MainReport from '@/Component/Brand/Reports';

export const metadata: Metadata = {
    title: "Reports | Connector Club",
    description: "",
};

const ReportPage = () => {
    return (
        <MainReport />
    );
}

export default ReportPage;
